import React from 'react';

import messages from '../reportingMessages';

import { canCreateRegistrationForUser } from '@/shared/components/registration/registrationHelpers';
import DataCacheService from '@/shared/services/DataCacheService';
import { Dropdown, MenuItem, SplitButton } from 'react-bootstrap';
import { FaCouch, FaPlus, FaSun } from 'react-icons/fa';
import DropdownMenu from 'react-bootstrap/lib/DropdownMenu';
import { FormattedMessage } from 'react-intl';

const AddAbsenceDropdownButton = ({ onOpenRegistrationModal, intl, userId }) => {
  const showOtherUser = !!userId && canCreateRegistrationForUser(userId);
  const showRecup = DataCacheService.timeTablesEnabled();
  const userName = !!userId ? DataCacheService.getUserName(userId) : null;

  const otherUserValues = { user: userName };
  return (
    <SplitButton
      onClick={() => onOpenRegistrationModal(3)}
      id="AddRegistrationButton"
      bsStyle="inverse"
      pullRight
      toggleLabel={intl.formatMessage(messages.AddAbsence)}
      title={
        <span>
          <FaPlus className="react-icon" />
          <FormattedMessage {...messages.AddAbsence} />
        </span>
      }
    >
      <MenuItem eventKey="1" onSelect={() => onOpenRegistrationModal(3)}>
        <FaSun className="react-icon fa-fw margin5R" />
        <FormattedMessage {...messages.AddAbsence} />
      </MenuItem>
      {showRecup ? (
        <MenuItem eventKey="2" onSelect={() => onOpenRegistrationModal(4)}>
          <FaCouch className="react-icon fa-fw margin5R" />
          <FormattedMessage {...messages.AddRecuperation} />
        </MenuItem>
      ) : null}

      {showOtherUser ? (
        <MenuItem eventKey="5" onSelect={() => onOpenRegistrationModal(3, userId)}>
          <FaSun className="react-icon fa-fw margin5R" />
          <FormattedMessage {...messages.AddAbsenceFor} values={otherUserValues} />
        </MenuItem>
      ) : null}
      {showOtherUser && showRecup ? (
        <MenuItem eventKey="5" onSelect={() => onOpenRegistrationModal(4, userId)}>
          <FaCouch className="react-icon fa-fw margin5R" />
          <FormattedMessage {...messages.AddRecuperationFor} values={otherUserValues} />
        </MenuItem>
      ) : null}
    </SplitButton>
  );
};
export default AddAbsenceDropdownButton;
